import React from "react";
import AuthLanding from "@components/templates/AuthLanding";

export default function AuthLandingScreen(): JSX.Element {
  return <AuthLanding />;
}
